import { defaultSortComparator } from '@components/DataGrid/types';

export interface SalesPerson {
	id: string;
	name: string;
	isActive?: boolean;
}

export function transformSalesPersonResponse(response: SalesPerson[]) {
	// SalesPerson is Active by default which is not in the API object then, so put it in there
	return response.map((sp) => ({ ...sp, isActive: sp.isActive ?? true })).sort((a, b) => defaultSortComparator(a.name, b.name));
}
